import React from 'react';

type SkeletonAnimation = 'pulse' | 'wave' | 'none';

interface SkeletonDashboardProps {
  cardCount?: number;
  animation?: SkeletonAnimation;
}

export const SkeletonDashboard: React.FC<SkeletonDashboardProps> = ({
  cardCount = 4,
  animation = 'wave',
}) => {
  const cardIndexes = Array.from({ length: cardCount });

  return (
    <div className="skeleton-dashboard">
      {cardIndexes.map((_, index) => (
        <div key={`dashboard-card-${index}`} className="skeleton-dashboard-card">
          <div className="skeleton skeleton-dashboard-icon" />
          <div className="skeleton skeleton-dashboard-title" />
          <div className="skeleton skeleton-dashboard-value" />
        </div>
      ))}
    </div>
  );
};

export default SkeletonDashboard;
